import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/services/api.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionarioService {
  constructor(
    private api: ApiService,
    private messageService: MessageService
  ) {}

  private questionario = new BehaviorSubject<any>([]);

  showMessage(message: string, status: string) {
    this.messageService.showMessage(message, status);
  }

  setQuestionario(questionario: any) {
    this.questionario.next(questionario);
  }

  getQuestionario() {
    return this.questionario.asObservable();
  }

  getSurveyByToken(token: string) {
    this.api.get(`/squestions/${token}/token`).subscribe({
      next: (res: any) => {
        const data = res?.data;

        this.setQuestionario(data);
      },
      error: (err) => {
        this.showMessage('Errore nel caricamento dei dati', 'error');
      },
      complete: () => {
        // if (this.data === null) {
        //   this.loaded = true;
        //   this.errorPage = true;
        // }
      },
    });
  }
}
